import { render, staticRenderFns } from "./ChangeStock.vue?vue&type=template&id=2652be93&scoped=true"
import script from "./ChangeStock.vue?vue&type=script&lang=js"
export * from "./ChangeStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2652be93",
  null
  
)

export default component.exports